/* RC: GAD collection page behaviour (spec 09; mockups 44/45 approved 2026-09-24).
   - Sticky offsets: the sort bar and the filter rail sit just under the stuck header (--rcc-top).
   - Quick view (Q3 panel, Q4 ink size buttons), opening QV1 "from the pill": the panel's clip starts
     at the pill's own rectangle and grows to the card. Phones get the same panel as a bottom sheet.
     One tap on a size adds that variant (cart drawer + bubble re-rendered, drawer stays closed).
   - Load more appends the next page's cards; Dawn's facets.js re-renders the grid on filter changes,
     so everything here is delegated.
   - Guide links in the filter groups (spec 13 round 2): "filter|text|link" lines from the section
     setting; added under the group's heading, again after every filter re-render. */
(function () {
  var root = document.documentElement;
  var header = document.querySelector('.section-header');

  /* ---------- sticky offsets ---------- */
  var ticking = false;
  function offsets() {
    ticking = false;
    var top = 0;
    if (header) {
      var r = header.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > 0) top = Math.round(r.bottom);
    }
    root.style.setProperty('--rcc-top', top + 'px');
    var tb = document.querySelector('.rcc-tb');
    if (tb) root.style.setProperty('--rcc-tb-h', tb.offsetHeight + 'px');
  }
  function queue() { if (!ticking) { ticking = true; requestAnimationFrame(offsets); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  offsets();

  /* ---------- quick view ---------- */
  var phone = window.matchMedia('(max-width: 749px)');
  var scrim = null;
  function showScrim(on) {
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'rcc-scrim';
      scrim.addEventListener('click', function () { closeAll(null); });
      document.body.appendChild(scrim);
    }
    scrim.classList.toggle('is-on', !!on);
  }
  function variants(card) {
    if (card._rccV) return card._rccV;
    var s = card.querySelector('[data-rcc-variants]');
    try { card._rccV = JSON.parse(s ? s.textContent : '[]'); } catch (e) { card._rccV = []; }
    return card._rccV;
  }
  function photos(card) {
    if (card._rccP) return card._rccP;
    var s = card.querySelector('[data-rcc-photos]');
    try { card._rccP = JSON.parse(s ? s.textContent : '{}'); } catch (e) { card._rccP = {}; }
    return card._rccP;
  }
  // Swatch -> that colour's variant photo, on the quick-view thumbnail and the card (as on the product page).
  function showColour(card, colour) {
    var ph = photos(card)[colour];
    if (!ph) return;
    var th = card.querySelector('[data-rcc-thumb]'), img = card.querySelector('.rcc-card__media img');
    if (th) th.src = ph.t;
    if (!img || img.getAttribute('src') === ph.m) return;
    var pre = new Image();
    pre.onload = pre.onerror = function () {
      if (card._rccC !== colour) return;
      img.srcset = ph.ss;
      img.src = ph.m;
    };
    card._rccC = colour;
    pre.src = ph.m;
  }
  function setClip(card) {
    var qv = card.querySelector('.rcc-qv'), pill = card.querySelector('.rcc-pill');
    if (!qv || !pill) return;
    var a = qv.getBoundingClientRect(), p = pill.getBoundingClientRect();
    if (!a.width || !p.width) return;
    qv.style.setProperty('--rcc-ci', [p.top - a.top, a.right - p.right, a.bottom - p.bottom, p.left - a.left]
      .map(function (n) { return Math.max(0, Math.round(n)) + 'px'; }).join(' '));
  }
  function refresh(card) {
    var list = variants(card), on = card.querySelector('.rcc-sw.on'), colour = on ? on.getAttribute('data-c') : null, anyOff = false;
    card.querySelectorAll('.rcc-qv__sz button').forEach(function (b) {
      var s = b.getAttribute('data-s');
      var ok = list.some(function (v) { return v.s === s && v.a && (colour === null || v.c === colour); });
      b.disabled = !ok;
      if (!ok) anyOff = true;
      b.classList.remove('is-added');
    });
    var note = card.querySelector('[data-rcc-note]');
    if (note) note.textContent = anyOff ? 'Struck sizes are sold out' : '';
    var okLine = card.querySelector('.rcc-qv__ok');
    if (okLine) okLine.classList.remove('is-err');
  }
  function open(card) {
    closeAll(card);
    var qv = card.querySelector('.rcc-qv'), pill = card.querySelector('.rcc-pill');
    if (!qv) return;
    refresh(card);
    setClip(card);
    card.classList.remove('is-added');
    card.classList.add('is-open');
    qv.setAttribute('aria-hidden', 'false');
    if (pill) pill.setAttribute('aria-expanded', 'true');
    if (phone.matches) showScrim(true);
    setTimeout(function () {
      var first = card.querySelector('.rcc-qv__sz button:not([disabled])') || card.querySelector('.rcc-qv__x');
      if (first && card.classList.contains('is-open')) first.focus({ preventScroll: true });
    }, 360);
  }
  function close(card, keepFocus) {
    var qv = card.querySelector('.rcc-qv'), pill = card.querySelector('.rcc-pill');
    setClip(card);
    card.classList.remove('is-open', 'is-added');
    if (qv) qv.setAttribute('aria-hidden', 'true');
    if (pill) { pill.setAttribute('aria-expanded', 'false'); if (!keepFocus && card.contains(document.activeElement)) pill.focus({ preventScroll: true }); }
    if (!document.querySelector('.rcc-card.is-open')) showScrim(false);
  }
  function closeAll(except) {
    document.querySelectorAll('.rcc-card.is-open').forEach(function (c) { if (c !== except) close(c, true); });
  }

  /* ---------- cart ---------- */
  function inner(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }
  var toastTimer;
  function toast(text) {
    var t = document.querySelector('[data-rcc-toast]');
    if (!t) return;
    t.querySelector('span').textContent = text;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  function addToCart(id) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add this item.');
        var s = j.sections || {};
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) bubble.innerHTML = inner(s['cart-icon-bubble'], '.shopify-section');
        if (drawer && s['cart-drawer']) {
          var box = document.getElementById('CartDrawer');
          if (box) box.innerHTML = inner(s['cart-drawer'], '#CartDrawer');
          drawer.classList.remove('is-empty');
          var di = drawer.querySelector('.drawer__inner');
          if (di) di.classList.remove('is-empty');
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        /* Dawn's pubsub: publish() is a global function, PUB_SUB_EVENTS a global const (not on window) */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rc-quick-view', productVariantId: id, cartData: j });
        }
        return j;
      });
    });
  }
  function openCart(e) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    closeAll(null);
    drawer.open();
  }
  function tapSize(btn) {
    var card = btn.closest('[data-rcc-card]'), list = variants(card), on = card.querySelector('.rcc-sw.on');
    var colour = on ? on.getAttribute('data-c') : null, s = btn.getAttribute('data-s');
    var v = list.filter(function (x) { return x.s === s && x.a && (colour === null || x.c === colour); })[0];
    if (!v) return;
    var okLine = card.querySelector('.rcc-qv__ok'), msg = okLine.querySelector('span');
    btn.classList.add('is-busy');
    addToCart(v.id).then(function () {
      card.querySelectorAll('.rcc-qv__sz button').forEach(function (b) { b.classList.remove('is-added'); });
      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      okLine.classList.remove('is-err');
      var label = (colour ? colour + ' · ' : '') + btn.textContent.trim();
      msg.textContent = 'Added · ' + label;
      card.classList.add('is-added');
      toast('Added to cart: ' + card.getAttribute('data-name') + ', ' + label);
    }).catch(function (err) {
      btn.classList.remove('is-busy');
      card.classList.remove('is-added');
      okLine.classList.add('is-err');
      msg.textContent = err.message;
    });
  }
  function addSingle(pill) {
    var card = pill.closest('[data-rcc-card]'), id = card.getAttribute('data-variant'), label = pill.querySelector('span');
    if (!id) return;
    pill.classList.add('is-busy');
    addToCart(id).then(function () {
      pill.classList.remove('is-busy');
      if (label) { var was = label.textContent; label.textContent = 'Added ✓'; setTimeout(function () { label.textContent = was; }, 1800); }
      toast('Added to cart: ' + card.getAttribute('data-name'));
    }).catch(function (err) { pill.classList.remove('is-busy'); toast(err.message); });
  }

  /* ---------- load more ---------- */
  function loadMore(link) {
    var section = link.closest('[data-rcc-section]'), grid = section && section.querySelector('#product-grid');
    if (!grid) return;
    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', grid.getAttribute('data-id'));
    link.classList.add('is-busy');
    fetch(url.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('#product-grid > li.rcc-item').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
      var next = doc.querySelector('[data-rcc-more]'), wrap = section.querySelector('[data-rcc-more-wrap]');
      if (next && wrap) {
        link.href = next.getAttribute('href');
        var shown = doc.querySelector('[data-rcc-shown]');
        if (shown) wrap.querySelector('[data-rcc-shown]').textContent = shown.textContent;
        link.classList.remove('is-busy');
      } else if (wrap) {
        wrap.remove();
      }
    }).catch(function () { window.location.href = link.href; });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var pill = t.closest('[data-rcc-pill]');
    if (pill) {
      var card = pill.closest('[data-rcc-card]');
      if (card.getAttribute('data-mode') === 'single') { addSingle(pill); return; }
      if (card.classList.contains('is-open')) close(card); else open(card);
      return;
    }
    if (t.closest('[data-rcc-close]')) { close(t.closest('[data-rcc-card]')); return; }
    var sw = t.closest('.rcc-sw');
    if (sw) {
      var c = sw.closest('[data-rcc-card]');
      c.querySelectorAll('.rcc-sw').forEach(function (x) { var on = x === sw; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
      var cn = c.querySelector('[data-rcc-cn]');
      if (cn) cn.textContent = sw.getAttribute('data-c');
      c.classList.remove('is-added');
      showColour(c, sw.getAttribute('data-c'));
      refresh(c);
      return;
    }
    var size = t.closest('.rcc-qv__sz button');
    if (size) { if (!size.disabled) tapSize(size); return; }
    if (t.closest('[data-rcc-viewcart]')) { openCart(e); return; }
    var more = t.closest('[data-rcc-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }
    if (!t.closest('.rcc-qv')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    var openCard = e.key === 'Escape' && document.querySelector('.rcc-card.is-open');
    if (openCard) close(openCard);
  });

  /* ---------- decoration video callout: plays while hovered ---------- */
  document.addEventListener('mouseover', function (e) {
    var v = e.target.closest && e.target.closest('[data-rcc-video]');
    if (!v || v.classList.contains('is-playing')) return;
    var video = v.querySelector('video');
    if (!video) return;
    v.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () { v.classList.remove('is-playing'); });
  });
  document.addEventListener('mouseout', function (e) {
    var v = e.target.closest && e.target.closest('[data-rcc-video]');
    if (!v || (e.relatedTarget && v.contains(e.relatedTarget))) return;
    var video = v.querySelector('video');
    if (video) video.pause();
    v.classList.remove('is-playing');
  });

  /* ---------- guide links in the filter groups ---------- */
  var fhost = document.querySelector('[data-rcc-fhelp]');
  if (fhost) {
    var frules = (fhost.getAttribute('data-rcc-fhelp') || '').split(/\n/).map(function (l) {
      var b = l.split('|');
      return b.length >= 3 && b[0].trim() ? { param: b[0].trim(), label: b[1].trim(), url: b[2].trim() } : null;
    }).filter(Boolean);
    var fapply = function () {
      frules.forEach(function (r) {
        document.querySelectorAll('input[name="' + r.param + '"]').forEach(function (inp) {
          var det = inp.closest('details');
          if (!det || det.querySelector(':scope > .rcc-fhelp')) return;
          var sum = det.querySelector(':scope > summary');
          if (!sum) return;
          var a = document.createElement('a');
          a.className = 'rcc-fhelp';
          a.href = r.url;
          a.textContent = r.label;
          sum.insertAdjacentElement('afterend', a);
        });
      });
    };
    if (frules.length) {
      fapply();
      var fbox = document.getElementById('main-collection-filters');
      if (fbox && window.MutationObserver) new MutationObserver(fapply).observe(fbox, { childList: true, subtree: true });
    }
  }
})();
